export const BRAND = {
  name: "Gudiksen Stays",
  parent: "Et brand under GGN Group ApS",
  legalName: "GGN Group ApS",
  cvr: "44163756",
  slogan: "Få flere bookinger. Vi klarer resten.",
  email: "gustav@gudiksenstays.dk",
  phone: "+45 20 83 93 96",
  phoneRaw: "+4520839396",
  address: {
    street: "Vestergade 23C, 1.3",
    city: "9300 Sæby",
    country: "Danmark",
  },
  calendlyUrl: "https://calendly.com/gustav-gudiksenstays/30min",
  logoUrl: "/gudiksen-logo-v3.png?v=1",
  social: {
    facebook: "https://www.facebook.com/gudiksenstays",
    instagram: "https://www.instagram.com/gudiksenstays",
    linkedin: "https://www.linkedin.com/in/gustav-gudiksen-nielsen-978287391/",
  },
};

export const CASES = [
  {
    slug: "jyllandsgade-apartment",
    name: "Jyllandsgade Apartment",
    location: "Aalborg C, Danmark",
    year: "2026",
    tagline: "Fra tom kalender til fast belægning.",
    summary:
      "Ejeren havde brugt for meget tid på gæstebeskeder og kalender-koordinering - uden at få de bookings, boligen fortjente. Vi overtog driften i starten af 2026 og satte hele forretningen op på ny.",
    heroImage:
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/v2p0uci7_2005437.jpg",
    gallery: [
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/v2p0uci7_2005437.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/yw75cpia_IMG_5345.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/6o9hf0j6_IMG_5348.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/xrwf178g_IMG_5347.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/ipibsih4_IMG_5354.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/1mp0iwgt_IMG_5358.jpeg",
    ],
    stats: [
      { k: "7 dage", v: "Fra overtagelse til fuld drift" },
      { k: "0 min", v: "Ejerens tid på gæstebeskeder" },
      { k: "Multi", v: "Alle store platforme aktiveret" },
    ],
    highlights: [
      "Fuld overtagelse af drift på under 7 dage",
      "Professionel annonce, ny prissætning og aktiv markedsføring",
      "Ejeren modtager nu månedlig udbetaling - uden en eneste gæstebesked",
      "Rengøring, check-in og check-out håndteret 100 % af os",
    ],
    description:
      "Ejeren havde forsøgt at drive udlejningen selv - men gæstebeskeder om aftenen, prissætning i weekenden og koordinering af rengøring blev hurtigt for meget ved siden af et fuldtidsjob. Boligen havde potentiale, men kalenderen fyldtes ikke som den skulle.\n\nVi overtog driften på under en uge. Annoncen blev skrevet om, priserne sat op efter reelle markedsdata og boligen aktiveret på alle relevante kanaler samt direkte via os. Fra dag ét overtog vi al gæstekommunikation, koordinerede rengøring og håndterede check-in.\n\nResultatet: en fyldt kalender - uden ejeren behøver at åbne en app.",
    testimonialId: null,
  },
  {
    slug: "jfk-suiten",
    name: "J.F. Kennedy Suiten",
    location: "Aalborg, Danmark",
    year: "2026",
    tagline: "Fra 'jeg har ikke tid' til 'jeg mærker det slet ikke'.",
    summary:
      "Zhenfei er selvstændig ingeniør. Suiten stod for det meste tom - ikke fordi den manglede potentiale, men fordi ingen havde tiden til at drifte den professionelt. Otte måneder senere kører driften helt uden hans indblanding.",
    heroImage:
      "https://customer-assets.emergentagent.com/job_luxury-hosting-2/artifacts/utmy3fv2_865847353.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_luxury-hosting-2/artifacts/utmy3fv2_865847353.jpg",
      "https://customer-assets.emergentagent.com/job_luxury-hosting-2/artifacts/jgw3j937_865847215.jpg",
      "https://customer-assets.emergentagent.com/job_luxury-hosting-2/artifacts/2616wwpp_865847171.jpg",
      "https://customer-assets.emergentagent.com/job_luxury-hosting-2/artifacts/dhwgten4_865847304.jpg",
    ],
    stats: [
      { k: "+133 %", v: "Højere belægning" },
      { k: "0 min", v: "Ejerens tid pr. uge" },
      { k: "24/7", v: "Vi håndterer alt" },
    ],
    highlights: [
      "+133 % højere belægning efter overtagelse",
      "0 gæstebeskeder til ejer - alt kommunikation håndteres af os",
      "Månedlig udbetaling direkte på konto - ingen efter-arbejde",
      "Fra 'jeg burde have flere bookings' til 'jeg tænker aldrig over det'",
    ],
    description:
      "Zhenfei kontaktede os fordi han var ved at drukne. Som selvstændig ingeniør havde han mere end rigeligt at se til - men gæstebeskeder om aftenen, prisvurdering og koordinering af rengøring blev en byrde han ikke havde tid til. Suiten stod tom uger ad gangen, og de bookings der kom ind blev håndteret i småbider mellem møder.\n\nVi overtog driften i starten af 2026 og gik straks i gang med at rette op på fundamentet: annoncen blev skrevet om og fotograferet på ny, prissætningen blev sat op efter reelle markedsdata, og boligen blev aktiveret på alle relevante kanaler samt direkte via os. Fra dag ét overtog vi al gæstekommunikation, kalender-koordinering, rengøring og løbende drift.\n\nResultatet: +133 % højere belægning, 0 gæstebeskeder på Zhenfeis telefon, og en månedlig udbetaling der lander uden han skal løfte en finger.",
    beforeAfter: {
      before: 30,
      after: 70,
      unit: "%",
      lift: "+133 %",
      metric: "Månedlig belægning",
      period: "8 måneder efter overtagelse",
      note:
        "Baseret på gennemsnitlig månedlig belægning før vs. efter overtagelse. Indikative tal.",
    },
    testimonialId: "zhenfei",
  },
  {
    slug: "lindholmsvej-96",
    name: "Bolig i Nørresundby",
    location: "Nørresundby, Danmark",
    year: "2026",
    tagline: "Fra privat udlejning til professionel firmabolig.",
    summary:
      "Brian ejer boligen i Nørresundby og ville gerne have den udlejet - uden selv at skulle stå for henvendelser, kontrakter og alt det praktiske. I dag kører boligen som møbleret firmabolig gennem Gudiksen Stays.",
    heroImage:
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/20nttm3w_billede%208.jpg",
    gallery: [
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/20nttm3w_billede%208.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/dgr13kwn_billede%20sovev%C3%A6relse%20lindholmdsvej%2096.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/a4qn6987_billede%207.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/hn4uyr3l_billede%20af%20haven%20lindholmsvej%2096%209400.png",
    ],
    stats: [
      { k: "Firmabolig", v: "Udlejet møbleret til virksomheder" },
      { k: "0 min", v: "Ejerens tid på henvendelser og drift" },
      { k: "1", v: "Fast kontaktpunkt for lejerne" },
    ],
    highlights: [
      "Boligen klargjort og præsenteret som møbleret firmabolig",
      "Alle henvendelser, kontrakter og fakturering håndteres af os",
      "Rengøring, sengetøj og forbrug koordineres som en del af aftalen",
      "Brian modtager udbetalingen - uden at skulle tænke over driften",
    ],
    description:
      "Brian havde en velholdt bolig i Nørresundby med eget køkken, badeværelse, have og parkering - og et ønske om at få den udlejet uden selv at skulle bruge tid på det. Han ville have en løsning, hvor han kunne være tryg ved, hvem der boede i boligen, og hvor han ikke skulle stå for den daglige kontakt.\n\nVi satte boligen op som møbleret firmabolig: fotograferet, beskrevet og gjort klar til virksomheder, der har brug for indkvartering til medarbejdere, montører og projektansatte. Vi håndterer alle henvendelser, aftaler, fakturering og koordinering af rengøring og sengetøj.\n\nResultatet: en bolig, der udlejes professionelt til virksomheder - og en ejer, der kan læne sig tilbage.",
    testimonialId: "brian",
  },
];

export const GUEST_BOOKING_URLS = {
  "jyllandsgade-apartment": "#",
  "jfk-suiten": "#",
};

export const TESTIMONIALS = [
  {
    id: "zhenfei",
    quote:
      "Som selvstændig ingeniør har jeg mere end rigeligt at se til i hverdagen. Før jeg gav driften videre til Gudiksen Stays, havde jeg ikke i nærheden af de bookings, jeg burde have. Gustav tog styringen fra dag ét - så jeg slipper for gæstebeskeder om aftenen, og driften kører nu uden jeg skal tænke over det.",
    name: "Zhenfei",
    role: "Selvstændig ingeniør · Ejer af J.F. Kennedy Suiten",
    photo:
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/16qfpfuu_1773603120141.jpg",
    caseSlug: "jfk-suiten",
  },
  {
    id: "brian",
    quote:
      "Jeg synes, det er skønt, at jeg ikke skal foretage mig noget. Gudiksen Stays har et professionelt setup, hvor alt fra henvendelser og kontrakter til det praktiske omkring boligen bliver håndteret for mig. Det kører bare - og jeg får min udbetaling uden at skulle tænke over det.",
    name: "Brian Nielsen",
    role: "Boligejer · Ejer af boligen i Nørresundby",
    photo:
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/taqpex1v_image.webp",
    caseSlug: "lindholmsvej-96",
  },
];

export const IMAGES = {
  /* Own property photo (J.F. Kennedy Suiten, stue) */
  hero: "https://customer-assets.emergentagent.com/job_luxury-hosting-2/artifacts/2616wwpp_865847171.jpg",
  portrait: "/gustav-cutout.png?v=3",
  portraitCutout:
    "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/uuphxsm9_IMG_5417-removebg-preview.png",
  portraitPhoto:
    "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/hnvit425_billede%20af%20mig%20juni%202026.webp",
  service1:
    "https://images.pexels.com/photos/14547138/pexels-photo-14547138.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  service2:
    "https://images.unsplash.com/photo-1711059985570-4c32ed12a12c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxib3V0aXF1ZSUyMGhvdGVsJTIwYmVkcm9vbXxlbnwwfHx8fDE3ODAzOTM2OTZ8MA&ixlib=rb-4.1.0&q=85&w=1400",
  service3:
    "https://images.pexels.com/photos/34688219/pexels-photo-34688219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  service4:
    "https://images.unsplash.com/photo-1680773525468-eda783c5bfe7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxzY2FuZGluYXZpYW4lMjBsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODAzOTM2OTZ8MA&ixlib=rb-4.1.0&q=85&w=1400",
};

export const SERVICES = [
  {
    id: "communication",
    title: "Gæstekommunikation",
    desc: "Hurtige, professionelle svar døgnet rundt. Vi tager hånd om alt fra forespørgsler til check-out.",
    image: IMAGES.service1,
    span: "md:col-span-7",
  },
  {
    id: "cleaning",
    title: "Koordinering af rengøring",
    desc: "Hotelstandard mellem hvert ophold. Vi planlægger, kvalitetssikrer og holder styr på linned og forbrugsvarer.",
    image: IMAGES.service2,
    span: "md:col-span-5",
  },
  {
    id: "pricing",
    title: "Pris- og listingoptimering",
    desc: "Dynamisk prisfastsættelse, professionelle billeder og en listing der konverterer - så din kalender altid er fuld.",
    image: IMAGES.service3,
    span: "md:col-span-5",
  },
  {
    id: "operations",
    title: "Drift og administration",
    desc: "Reviews, reklamationer, vedligehold og rapportering. Du modtager omsætningen - vi tager resten.",
    image: IMAGES.service4,
    span: "md:col-span-7",
  },
];

export const VALUES = [
  {
    n: "01",
    title: "Flere bookinger",
    desc: "Målrettet markedsføring på alle relevante bookingplatforme og direkte via vores egne kanaler - så din kalender fyldes.",
  },
  {
    n: "02",
    title: "Højere indtjening",
    desc: "Dynamisk prissætning der justerer efter efterspørgsel, sæson og lokale events. Din bolig sælges altid til den rigtige pris.",
  },
  {
    n: "03",
    title: "Passiv indkomst",
    desc: "Vi håndterer gæstekommunikation, rengøring, klargøring og alle bookinger. Du modtager udbetalingen - vi klarer resten.",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Gratis gennemgang af din bolig",
    desc: "Vi vurderer din bolig, dit indtjeningspotentiale og din nuværende performance - uden binding og uden krav.",
    tag: "30 min · Online eller på stedet",
  },
  {
    n: "02",
    title: "Vi optimerer og markedsfører",
    desc: "Professionelle billeder, SEO-optimeret annonce, dynamisk prissætning og synlighed på alle relevante platforme fra dag ét.",
    tag: "0 kr. i opstart · Klar inden 7 dage",
  },
  {
    n: "03",
    title: "Vi håndterer gæster, kalender og rengøring",
    desc: "24/7 gæstekommunikation, koordinering af rengøring, klargøring og løbende drift. Ét samlet system, du ikke skal tænke over.",
    tag: "Fuldt hands-off for dig",
  },
  {
    n: "04",
    title: "Du modtager udbetalingerne",
    desc: "Månedlig rapportering og udbetaling. Du følger udviklingen i realtid - vi tager os af alt det praktiske.",
    tag: "Fuld gennemsigtighed",
  },
];

export const PRICING = {
  startup: { value: "0 kr.", label: "Opstartsomkostning" },
  fee: { value: "0 kr.", label: "Månedligt gebyr" },
  hidden: { value: "0 kr.", label: "Skjulte gebyrer" },
};

/* Corporate housing catalog — add a new entry to expose /firmaboliger/{slug} automatically.
   Optional fields (sqm, guests, bedrooms, amenities, highlights, headline) are rendered only when present. */
export const CORPORATE_HOMES = [
  {
    slug: "baelum",
    title: "Bondegård i Bælum - Møbleret bolig på landet",
    shortTitle: "Bondegård i Bælum",
    area: "Bælum",
    sqm: 250,
    tagline: "Møbleret bondegård på landet med udestue og udsigt over markerne.",
    coverImage:
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/5y1ol4km_zhenfei%20bondeg%C3%A5rd%20billede%203.jpg",
    gallery: [
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/5y1ol4km_zhenfei%20bondeg%C3%A5rd%20billede%203.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/3sbnvqbf_zhenfei%20bondeg%C3%A5rd%20billede%206.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/4t4b0mxf_zhenfei%20bondeg%C3%A5rd%20billede%2026%20%28optimeret%29.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/918pg70z_zhenfei%20bondeg%C3%A5rd%20billede%2022%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/zhk2wk9t_zhenfei%20bondeg%C3%A5rd%20billede%2027%20%28optimeret%29.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/arwrmw8v_zhenfei%20bondeg%C3%A5rd%20billede%2020%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/337r1z14_zhenfei%20bondeg%C3%A5rd%20billede%2031%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/7v7s8du9_zhenfei%20bondeg%C3%A5rd%20billede%2030%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/hog2kjgp_zhenfei%20bondeg%C3%A5rd%20billede%2023%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/yy7lqgv3_zhenfei%20bondeg%C3%A5rd%20billede%2021%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/ouuwrhou_zhenfei%20bondeg%C3%A5rd%20billede%2019%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/p76hnzqw_zhenfei%20bondeg%C3%A5rd%20billede%2024%20%28optimeret%29.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/jgj6qen2_zhenfei%20bondeg%C3%A5rd%20billede%205.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/l1ei34zt_zhenfei%20bondeg%C3%A5rd%20billede%201.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/0zkp9cnj_zhenfei%20bondeg%C3%A5rd%20billede%207.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/xqn6td1s_zhenfei%20bondeg%C3%A5rd%20billede%2029%20%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/qqywtgdv_zhenfei%20bondeg%C3%A5rd%20billede%208.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/udxalkqj_zhenfei%20bondeg%C3%A5rd%20billede%2017%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/4xgyd5dl_zhenfei%20bondeg%C3%A5rd%20billede%204.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/lobn07nv_zhenfei%20bondeg%C3%A5rd%20billede%202.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/fyldo24z_zhenfei%20bondeg%C3%A5rd%20billede%2025%20%28optimeret%29.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/ssn5vb2m_zhenfei%20bondeg%C3%A5rd%20billede%2018%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/m0uzlxx7_zhenfei%20bondeg%C3%A5rd%20billede%2028%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/3svvh0ep_zhenfei%20bondeg%C3%A5rd%20billede%2015%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/ke6yhjfg_zhenfei%20bondeg%C3%A5rd%20billede%2014%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/5koqhii4_zhenfei%20bondeg%C3%A5rd%20billede%2016%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/h6uvyi93_zhenfei%20bondeg%C3%A5rd%20billede%2013%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/2f58y15z_zhenfei%20bondeg%C3%A5rd%20billede%2010%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/l7if45eo_zhenfei%20bondeg%C3%A5rd%20billede%2012%20%28optimeret%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/osyyex1c_Zhenfei%20bondeg%C3%A5rd%20billede%2011%20%28optimeret%29.png",
    ],
    amenities: ["TV", "Wi-Fi", "Sengetøj inkluderet"],
    description:
      "Bondegården på ca. 250 m² ligger i rolige, landlige omgivelser ved Bælum med udestue, overdækket gårdsplads og udsigt over markerne - et godt udgangspunkt for medarbejdere og teams, der arbejder i området.\n\nKontakt os for detaljer om antal personer og faciliteter - vi vender tilbage med tilgængelighed og pris hurtigst muligt.",
  },
  {
    slug: "jfk-suiten",
    title: "J.F. Kennedy Suiten - Møbleret bolig i Aalborg",
    shortTitle: "J.F. Kennedy Suiten",
    area: "Aalborg",
    sqm: 117,
    guests: 8,
    tagline: "Rummelig møbleret suite i Aalborg - til korte og længere ophold.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_luxury-hosting-2/artifacts/2616wwpp_865847171.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_luxury-hosting-2/artifacts/2616wwpp_865847171.jpg",
      "https://customer-assets.emergentagent.com/job_luxury-hosting-2/artifacts/utmy3fv2_865847353.jpg",
      "https://customer-assets.emergentagent.com/job_luxury-hosting-2/artifacts/jgw3j937_865847215.jpg",
      "https://customer-assets.emergentagent.com/job_luxury-hosting-2/artifacts/dhwgten4_865847304.jpg",
    ],
    amenities: ["TV", "Wi-Fi", "Sengetøj inkluderet"],
    description:
      "J.F. Kennedy Suiten er en rummelig møbleret suite på ca. 117 m² i Aalborg med plads til op til 8 personer - velegnet til teams, montører og projektansatte på både kortere og længere ophold.\n\nKontakt os for yderligere detaljer om indretning og faciliteter - vi vender tilbage med tilgængelighed og pris hurtigst muligt.",
  },
  {
    slug: "jyllandsgade-apartment",
    title: "Jyllandsgade Apartment - Møbleret bolig i Aalborg C",
    shortTitle: "Jyllandsgade Apartment",
    area: "Aalborg",
    sqm: 57,
    guests: 4,
    tagline: "Møbleret lejlighed centralt i Aalborg - til korte og længere ophold.",
    coverImage:
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/yw75cpia_IMG_5345.jpeg",
    gallery: [
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/yw75cpia_IMG_5345.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/v2p0uci7_2005437.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/6o9hf0j6_IMG_5348.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/xrwf178g_IMG_5347.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/ipibsih4_IMG_5354.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/1mp0iwgt_IMG_5358.jpeg",
    ],
    amenities: ["TV", "Wi-Fi", "Sengetøj inkluderet"],
    description:
      "Jyllandsgade Apartment er en møbleret lejlighed på ca. 57 m² centralt i Aalborg med plads til op til 4 personer - lige til at flytte ind i for medarbejdere, konsulenter og projektansatte.\n\nKontakt os for yderligere detaljer om indretning og faciliteter - vi vender tilbage med tilgængelighed og pris hurtigst muligt.",
  },
  {
    slug: "lindholmsvej-96",
    title: "Bolig i Nørresundby - Møbleret firmabolig",
    shortTitle: "Bolig i Nørresundby",
    area: "Nørresundby",
    sqm: 57,
    guests: 4,
    bedrooms: "1 soveværelse + sovesofa",
    tagline: "Praktisk og fuldt møbleret bolig - klar til korte og længere virksomhedsophold.",
    coverImage:
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/20nttm3w_billede%208.jpg",
    gallery: [
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/20nttm3w_billede%208.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/finv9fh8_billede%201.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/eqd4t4w3_bord%20b%C3%A6nkes%C3%A6t%20lindholmsvej%2096.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/hn4uyr3l_billede%20af%20haven%20lindholmsvej%2096%209400.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/dgr13kwn_billede%20sovev%C3%A6relse%20lindholmdsvej%2096.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/a4qn6987_billede%207.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/7crdnwkn_billede%203%20%20%281%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/bujy9ktq_billede%2012.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/w51sbcjs_billede%209.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/nc5250t8_billede%202%20%20%281%29.png",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/5ae3synd_billede%2010.jpg",
      "https://customer-assets-agu9un31.emergentagent.net/job_luxury-hosting-2/artifacts/g193l45g_billede%2011.jpg",
    ],
    amenities: [
      "Fuldt møbleret",
      "Op til 4 personer",
      "Køkken",
      "Badeværelse",
      "Vaskemaskine",
      "TV",
      "Wi-Fi",
      "Sengetøj inkluderet",
      "Parkering ved boligen",
      "Terrasse & have",
      "Egnet til både korte og længere virksomhedsophold",
    ],
    headline: "Fuldt møbleret bolig i Nørresundby - klar til dine medarbejdere.",
    description:
      "Boligen i Nørresundby er en fuldt møbleret bolig på ca. 57 m² med 1 separat soveværelse samt en sovesofa i opholdsstuen - i alt plads til op til 4 personer.\n\nBoligen er praktisk indrettet med eget køkken, badeværelse med bruser, vaskemaskine, Wi-Fi og parkering ved boligen. Den er lige til at flytte ind i for medarbejdere, montører eller projektansatte på både kortere og længere ophold.",
    highlights: [
      "Ét fast kontaktpunkt fra forespørgsel til udflytning",
      "Rengøring, sengetøj og forbrug kan indgå i aftalen",
      "Månedlig fakturering med EAN eller almindelig virksomhedsfaktura",
      "Fleksibel opholdslængde - fra få uger til flere måneder",
    ],
  },
];

/* Shared "who we are" copy — used on landing (WhoWeAre) and /om-os. */
export const ABOUT = {
  intro:
    "Gudiksen Stays er en dansk udlejnings- og driftsvirksomhed med base i Sæby, der arbejder med boliger i hele landet. Vi tilbyder møblerede boliger til både korte og længere ophold - og står for hele driften for de boligejere, der lægger deres bolig i vores hænder.",
  offerings: [
    {
      n: "01",
      title: "Møblerede boliger til længere ophold",
      desc: "Firmaboliger til virksomheder, medarbejdere, konsulenter og projektansatte - klar til indflytning fra få uger til flere måneder.",
      to: "/firmaboliger",
      cta: "Se firmaboliger",
    },
    {
      n: "02",
      title: "Korttidsudlejning til gæster",
      desc: "Ophold til weekend, ferie og forretningsrejse i vores egne boliger - med professionel gæstekontakt og hotelstandard mellem hvert ophold.",
      to: "/for-gaester",
      cta: "Find ophold",
    },
    {
      n: "03",
      title: "Drift for boligejere",
      desc: "Vi håndterer annoncering, prissætning, gæstekommunikation, rengøring og løbende drift - du modtager udbetalingen.",
      to: "/#boligejere",
      cta: "Udlej din bolig",
    },
  ],
  goal:
    "Vores mål er at blive Danmarks foretrukne partner for møblerede ophold - ét sted, hvor gæster og virksomheder finder en bolig i hotelstandard, og hvor boligejere trygt kan overlade udlejning og drift til os. Vi vokser gradvist med flere boliger i porteføljen - altid med den personlige service i centrum.",
};

export const SERVICE_INCLUDES = [
  "Annonceoprettelse & SEO-optimering",
  "Multiplatform synlighed på alle relevante kanaler",
  "Professionelle fotos af din bolig",
  "Dynamisk prisoptimering · 24/7",
  "Gæstekommunikation døgnet rundt",
  "Screening af gæster & skadesbeskyttelse",
  "Koordinering af rengøring & linned",
  "Vedligehold, support og nøgleovergang",
  "Månedlig rapport & fuld gennemsigtighed",
];
